import { PropertiesDebt, PropertiesSale, PropertiesTax } from 'src/common-services'

export const sortSales = (sales: PropertiesSale[]) => {
  const temp = [...sales]
  return temp.sort((a, b) => {
    if (!a.recordedDate || !b.recordedDate) {
      return 1
    }
    const aData = new Date(a.recordedDate)
    const bData = new Date(b.recordedDate)
    return aData < bData ? 1 : -1
  })
}

export const sortTaxes = (taxes: PropertiesTax[]) => {
  const temp = [...taxes]
  return temp.sort((a, b) => {
    if (!a.taxYear || !b.taxYear) {
      return 1
    }
    return a.taxYear < b.taxYear ? 1 : -1
  })
}

export const sortDebts = (debts: PropertiesDebt[]) => {
  const temp = [...debts]
  return temp.sort((a, b) => {
    if (!a.date || !b.date) {
      return 1
    }
    const aData = new Date(a.date)
    const bData = new Date(b.date)
    return aData < bData ? 1 : -1
  })
}
